import { render } from "./DynamicHeader.vue?vue&type=template&id=d77e8986"
import script from "./DynamicHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicPlayer/DynamicHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d77e8986"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d77e8986', __exports__)) {
    api.reload('d77e8986', __exports__)
  }
  
  module.hot.accept("./DynamicHeader.vue?vue&type=template&id=d77e8986", () => {
    api.rerender('d77e8986', render)
  })

}


export default __exports__